import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';

const getSdk = async () => import('@tencent/td-addon-sdk-docs');

export default class AddonReport {
    public static reportAddonIframeClick = async (addonId: string): Promise<void> => {
        const { DocAddonBridge } = await getSdk();
        const { name } = await DocAddonBridge.getAddon(addonId, { needInstalled: false });
        tdw({
            action: 'clk',
            module: 'iframe_container',
            opername: 'doc_addon_use',
            ver6: addonId,
            ver7: name,
        });
    };
}
